export type BuildingType = "Bungalow" | "Story Building";

export class BuildingTypeImages {
    static readonly bungalowImage = "https://www.thespruce.com/thmb/zFg7mPetp_7ZVqcScgJHbc7PSTg=/1500x0/filters:no_upscale():max_bytes(150000):strip_icc()/GettyImages-523075374-8d27b929fdfc4702aab5c73f821a65de.jpg";
    static readonly storyBuildingImage = "https://storables.com/wp-content/uploads/2023/11/how-tall-is-a-3-story-apartment-building-1700108112.jpg";
}